export default ({ get, checkStatus, toJSON }) => ({
  getVideoDetails: (id) =>
    get(`universe/v1/videos/${id}`).then(checkStatus).then(toJSON),
  getHeroVideo: (id) =>
    get(`/universe/v1/hero_video/search?video_ids=[${id}]`)
      .then(checkStatus)
      .then(toJSON),
  getDefaultHeroVideo: () =>
    get("universe/v1/hero_video/default").then(checkStatus).then(toJSON),
  getRecentlyPublishedVideos: () =>
    get("universe/v1/newest_videos").then(checkStatus).then(toJSON),
  getChampiverseVideos: () =>
    get("universe/v1/champiverse_videos").then(checkStatus).then(toJSON),
});
